export default class {
    constructor (lodash) {
        this.lodash = lodash;
    }
    parseErrors (response) {
        if (!Array.isArray(response.data)) {
            return {};
        }
        return response.data.reduce((original, error) => {
            if (error.path) {
                this.lodash.set(original, `${error.path}.${error.field}`, error.message);
            }
            else {
                original[error.field] = error.message;
            }
            return original;
        }, {});
    }
}



// WEBPACK FOOTER //
// ./src/app/services/response/index.js